import {
  FloatingFormItem,
  InputDate,
  PlanAccountsSelect,
} from '@/components/_common';
import {
  PlanAccountDestination,
  PlanAccountHierarchy,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { InstallmentReverseFormValues } from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { useAccountReceivableReverseInstallment } from '@/core/domain/financial/AccountReceivable/AccountReceivable.hooks';
import { useDefaultEmptyFieldError } from '@/hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { DateTimeFormat } from '@/utils/moment';
import { Button, Col, Form, Modal, ModalProps, Row } from 'antd';
import moment from 'moment';

import React from 'react';

interface Props extends Omit<ModalProps, 'onOk'> {
  onCancel: () => void;
  data: { id?: number; installmentReceivableId?: number };
}

const AccountReceivableReverseInstallmentModal: React.FC<Props> = ({
  onCancel,
  open,
  data,
}) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const [form] = Form.useForm<InstallmentReverseFormValues>();

  const today = moment().format('YYYY-MM-DD');
  const reversalDate = Form.useWatch('reversalDate', form);

  const isEarlierDate = moment(reversalDate).isBefore(today);

  const reverseInstallmentMutation = useAccountReceivableReverseInstallment();

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleOk = async () => {
    const values = await form.validateFields();
    if (data) {
      await reverseInstallmentMutation.mutateAsync({
        ...data,
        ...values,
        reversalDate: values.reversalDate.format(DateTimeFormat),
      });

      handleCancel();
    }
  };

  return (
    <Modal
      width={600}
      open={open}
      onCancel={handleCancel}
      title={'Estorno'}
      footer={[
        <Button type="primary" ghost onClick={onCancel}>
          Cancelar
        </Button>,
        <Button
          type="primary"
          loading={reverseInstallmentMutation.isLoading}
          onClick={handleOk}
          disabled={
            isEarlierDate &&
            !hasPermissions([
              Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_SETTLE_REFUND_WITH_PREVIOUS_DATE,
            ])
          }
        >
          Estornar
        </Button>,
      ]}
      destroyOnClose
    >
      <Form form={form}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <FloatingFormItem
              name={'planAccountId'}
              label={'Plano de contas'}
              rules={[defaultEmptyFieldError]}
            >
              <PlanAccountsSelect
                queryFilter={{
                  active: true,
                  hierarchy: PlanAccountHierarchy.Analitical,
                  destination: PlanAccountDestination.Expense,
                }}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              name={'reversalDate'}
              label={'Data de estorno'}
              rules={[defaultEmptyFieldError]}
              initialValue={moment()}
            >
              <InputDate />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AccountReceivableReverseInstallmentModal;
